module.exports = __webpack_public_path__ + "static/010.thumb-2f1dacf531a9d429689fa7546831481a.jpg";